import { combineReducers, type Reducer } from 'redux';

import { apiCallReducer } from '../domain/service/redux/api.redux';
import { assetDataReducer } from '../domain/service/redux/assetData.redux';
import { trackingAdministrationReducer } from '../domain/service/redux/trackingAdminstration.redux';
import { trackingDataReducer } from '../domain/service/redux/trackingData.redux';
import appReducer from './app/redux/reducers';
import langReducer from './configuration/lang/reducer';
import { loginReducer } from './configuration/login/reducer';
import configReducer from './configuration/setup/configReducer';
import { tokenHandlingReducer } from './configuration/tokenHandling/reducer';

export const rootReducer = (): Reducer =>
    combineReducers({
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenHandlingReducer,
        assetData: assetDataReducer,
        api: apiCallReducer,
        trackingData: trackingDataReducer,
        trackingAdministration: trackingAdministrationReducer,
    });
